import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // The search object currently open in dashboard view (null = show list)
  activeSearch: null,
  slrContext: null,
};

const literatureDiscoverySlice = createSlice({
  name: 'literatureDiscovery',
  initialState,
  reducers: {
    setActiveSearch(state, action) {
      state.activeSearch = action.payload;
    },

    clearActiveSearch(state) {
      state.activeSearch = null;
    },

    setSLRContext(state, action) {
      state.slrContext = action.payload;
    },

    clearSLRContext(state) {
      state.slrContext = null;
    },

    resetLiteratureDiscoveryState() {
      return initialState;
    },
  },
});

export const {
  setActiveSearch,
  clearActiveSearch,
  setSLRContext,
  clearSLRContext,
  resetLiteratureDiscoveryState,
} = literatureDiscoverySlice.actions;

export default literatureDiscoverySlice.reducer;